<template>
    <div>
    </div>
</template>
<script>
import {setCookie,getCookie} from '../../assets/js/cookie.js'
export default {
    data(){
        return{
            is_success:'',
            notify_id:'',
            real_name:'',
            token:'',
            user_id:'',
            sign:'',
            sign_type:'',
        }
    },
    mounted(){
        
        this.is_success = this.$route.query.is_success;
        this.notify_id = this.$route.query.notify_id;
        this.real_name = this.$route.query.real_name;
        this.token = this.$route.query.token;
        this.user_id = this.$route.query.user_id;
        this.sign = this.$route.query.sign;
        this.sign_type = this.$route.query.sign_type;
        this.login();
    },
    methods:{
        login(){
            let that = this;
            let data = {'is_success':this.is_success,'notify_id':this.notify_id,'real_name':this.real_name,'token':this.token,'user_id':this.user_id,'sign':this.sign,'sign_type':this.sign_type};
            this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/login/alipaylogin.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8'
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code){
                        that.GLOBAL.token = res.data.token
                        setCookie('2officesessionid',res.data.token,60*60*10)
                        location.href = '/main';
                    }
                    else{
                        alert("认证失败!重新返首页登录");
                        location.href = '/';
                    }
                })
        }
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/alipaylogin/alipaylogin.vue